import styled from "styled-components";

export const Box = styled.div`
  --primary-color: #8cc540;
  --primary-hover: #7ab036;
  --secondary-color: #6366f1;
  --text-color: #1f2937;
  --muted-color: #6b7280;
  --card-bg: #ffffff;
  --border-color: #e2e8f0;

  .interDisplay {
    font-family: "Inter", sans-serif;
  }
  .defaultText {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }

  .container {
    max-width: 960px;
    background: var(--card-bg);
    border: 1px solid var(--border-color);
    border-radius: 16px;
    padding: 24px;
    margin: 0 auto;
  }

  .input-group-nowrap {
    display: flex;
    flex-wrap: nowrap;
    gap: 15px;
    align-items: center;
    width: 100%;
  }

  .form-control,
  .form-select {
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 16px;
    border: 1px solid var(--border-color);
    transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
    &:focus {
      border-color: var(--primary-color);
      box-shadow: 0 0 0 0.25rem rgba(140, 197, 64, 0.25);
    }
    &.is-invalid {
      border-color: #dc3545;
    }
  }

  .topic-input {
    border-radius: 8px 0 0 8px !important;
    flex-grow: 1;
    width: auto;
  }

  .platform-dropdown {
    .dropdown-toggle {
      border-radius: 0 8px 8px 0 !important;
      padding: 12px 16px;
      font-size: 16px;
      border: 1px solid var(--border-color) !important;
      border-left: none !important;
      background: var(--card-bg);
      color: var(--text-color);
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: auto;
      max-width: 100%;
      white-space: nowrap;
      transition: background-color 0.2s ease-in-out,
      transform 0.2s ease-in-out;

      &:hover {
        background: var(--primary-color);
        color: #fff;
        transform: scale(1.02);
      }

      &::after {
        margin-left: 8px;
      }

      svg {
        font-size: 1.2rem;
      }
    }

    .dropdown-menu {
      border-radius: 8px;
      padding: 8px;
      min-width: 110px;

      .dropdown-item {
        padding: 8px 12px;
        border-radius: 6px;
        font-size: 14px;
        display: flex;
        align-items: center;
        gap: 8px;

        &:hover {
          background: var(--primary-hover);
          color: #fff;
        }

        svg {
          font-size: 1.1rem;
        }
      }
    }
  }

  .generate-button {
    background: var(--primary-color);
    border: none;
    font-weight: 400 !important;
    padding: 12px 24px;
    border-radius: 12px;
    font-size: 16px;
    transition: background-color 0.2s ease-in-out, transform 0.2s ease-in-out;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    &:hover {
      background: var(--primary-hover);
      transform: scale(1.05);
    }
    &:disabled {
      background: #b3d680;
      cursor: not-allowed;
      transform: none;
    }
    svg, span {
      display: inline-flex;
      align-items: center;
    }
    @media (max-width: 576px) {
      width: 100%;
      padding: 14px;
      font-size: 15px;
      border-radius: 10px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
      span {
        gap: 6px;
      }
    }
  }

  .card {
    border: none;
    border-radius: 12px;
    background: var(--card-bg);
    transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
    &.animate-card {
      transform: translateY(0);
      opacity: 1;
      animation: slideUp 0.3s ease-in-out;
    }
  }

  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .badge {
    background: var(--secondary-color);
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    border-radius: 20px;
    transition: background-color 0.2s ease-in-out;
    &:hover {
      background: #4f46e5;
    }
  }

  .fw-semibold {
    color: var(--text-color);
    font-size: 1.25rem;
  }

  .text-muted {
    font-size: 0.875rem;
    color: var(--muted-color);
  }

  @media (max-width: 768px) {
    .container {
      padding: 16px;
    }
    .form-control,
    .form-select {
      font-size: 14px;
      padding: 10px 12px;
    }
    .row.g-3 {
      gap: 12px;
    }
  }

  @media (min-width: 992px) {
    .container {
      padding: 32px;
    }
    .form-control,
    .form-select {
      font-size: 16px;
    }
    .generate-button {
      min-width: 200px;
    }
  }
  @media (max-width: 570px) {
    .input-group-nowrap {
      display: block;
    }

    input#topicInput {
      margin-bottom: 10px;
    }

    button.dropdown-toggle.btn.btn-outline-primary {
      width: 133px;
      height: 44px !important;
    }
  }

  button.dropdown-toggle.btn.btn-outline-primary {
    height: 50px !important;
    width: 123px !important;
  }
`;